// extracted by mini-css-extract-plugin
export var aggregationCell = "_2f-k";
export var aggregationRow = "_2f-j";
export var borderlessSpinnerContainer = "_2f-3";
export var closeIcon = "_2f-c";
export var columnHeaderSurface = "_2f-8";
export var columnHeaderSurfaceDragOverlay = "_2f-s";
export var columnHeaderSurfaceResizing = "_2f-p";
export var contextMenuAnchor = "_2f-1";
export var draggableColumnHeader = "_2f-q";
export var draggableColumnHeaderOverlay = "_2f-r";
export var expandIcon = "_2f-d";
export var expanded = "_2f-e";
export var filterDropdown = "_2f-f";
export var filterDropdownDivider = "_2f-a";
export var filterDropdownHeader = "_2f-i";
export var filterDropdownItem = "_2f-h";
export var filterDropdownModal = "_2f-g _2f-f";
export var filterItem = "_2f-9";
export var normalCellWithAdjustableBorder = "_2f-b";
export var pinButtonContainer = "_2f-l";
export var pinIcon = "_2f-m";
export var pinIconActive = "_2f-n";
export var spinner = "_2f-0";
export var spinnerContainer = "_2f-2";
export var tableContainer = "_2f-4";
export var tableContentDraggingColumns = "_2f-7";
export var tableContentInner = "_2f-6";
export var tableContentWrapper = "_2f-5";
export var viewButtonContainer = "_2f-o";